import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ReactComponent as Close } from '../../assets/images/svg/close.svg';
import themeColors from '../../assets/styles/themeColors';

const CloseStyled = styled(Close)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  stroke: ${({ color }) => color || themeColors.colorTextSecondary};
`;

const CloseIcon = (props) => <CloseStyled {...props} />;

CloseIcon.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

CloseIcon.defaultProps = {
  w: '24px',
  h: '24px',
};

export default CloseIcon;
